// Feature flags configuration
// Set to true to enable a feature, false to disable

export interface FeatureConfig {
  enabled: boolean;
  route?: string;
  menuKey?: string;
}

export interface Features {
  users: FeatureConfig;
  newsFeed: FeatureConfig;
  bookingSpace: FeatureConfig;
  deskBooking: FeatureConfig;
  inductions: FeatureConfig;
  buildingContacts: FeatureConfig;
  issues: FeatureConfig;
  featureManagement: FeatureConfig;
  serviceNowSettings: FeatureConfig;
  inceptionSettings: FeatureConfig;
  visitorManagement: FeatureConfig;
}

export const FEATURES: Features = {
  users: {
    enabled: true,
    route: '/users',
    menuKey: 'users'
  },
  newsFeed: {
    enabled: true,
    route: '/news-feed',
    menuKey: 'news-feed'
  },
  bookingSpace: {
    enabled: true,
    route: '/booking-space',
    menuKey: 'booking-space'
  },
  deskBooking: {
    enabled: false,
    route: '/desk-booking',
    menuKey: 'desk-booking'
  },
  inductions: {
    enabled: true,
    route: '/inductions',
    menuKey: 'inductions'
  },
  buildingContacts: {
    enabled: true,
    route: '/building-contacts',
    menuKey: 'building-contacts'
  },
  issues: {
    enabled: true,
    route: '/issues',
    menuKey: 'issues'
  },
  featureManagement: {
    enabled: true,
    route: '/feature-management',
    menuKey: 'feature-management'
  },
  serviceNowSettings: {
    enabled: true,
    route: '/service-now-settings',
    menuKey: 'service-now-settings'
  },
  inceptionSettings: {
    enabled: true,
    route: '/ir-inception-settings',
    menuKey: 'ir-inception-settings'
  },
  visitorManagement: {
    enabled: true,
    route: '/visitor-management',
    menuKey: 'visitor-management'
  }
};

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (featureKey: keyof Features): boolean => {
  return FEATURES[featureKey]?.enabled ?? false;
};

// Get all enabled features
export const getEnabledFeatures = (): Array<keyof Features> => {
  return (Object.keys(FEATURES) as Array<keyof Features>).filter(key =>
    FEATURES[key].enabled
  );
};
